import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import RelatedInvoiceRow from './RelatedInvoiceRow';
import { PAYMENT_ORIGIN_COLOR } from './styleConstants';

const RelatedInvoicesList = ({ relatedInvoices }) => {
  const { t } = useTranslation();

  if (!relatedInvoices.length) {
    return (
      <Box sx={{ padding: '28px 20px', color: PAYMENT_ORIGIN_COLOR, fontSize: '13px' }}>
        {t('TRANSACTION.DETAIL.NO_ASSOCIATED_INVOICES')}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid' }}>
      {relatedInvoices.map(relatedInvoice => (
        <RelatedInvoiceRow key={relatedInvoice.invoiceId} {...relatedInvoice} />
      ))}
    </Box>
  );
};

RelatedInvoicesList.propTypes = {
  relatedInvoices: PropTypes.array.isRequired
};

export default RelatedInvoicesList;
